import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { localStorageService } from './services/localstorage.service';
import { MainService } from './services/main.service';

export const authGuard: CanActivateFn = async (route, state) => {
    const _local = inject(localStorageService);
    const _main = inject(MainService);
    const router = inject(Router);
    const exemptedUrls = ['/login', '/register', '/', '/app/404', '/new-password', '/confirm', '/business-info', '/business-Info', '/forgot-password', '/receipt/:token'];
    if (await isAuthenticated()) {
        const menu = _local.customGetItem('menu') || [];
        const currentUrl = state.url.split('?')[0];
        let matching_url = false;
        loop1: for (const element of menu) {
            if (element.path == currentUrl) {
                matching_url = true;
                break loop1;
            }
            if (element.submenu?.length) {
                loop2: for (const subitem of element.submenu) {
                    if (subitem.path == currentUrl) {
                        matching_url = true;
                        break loop2;
                        // break loop1;
                    }
                }
            }
        }
        if (!matching_url && !exemptedUrls.includes(currentUrl)) {
            return router.parseUrl('/app/404');
        }
        return true;
    } else {
        if (_main.path_redirect_to && _main.path_redirect_to.includes('website')) {
            router.navigate(['/register'], { queryParamsHandling: 'merge' });
            return false;
        } else {
            _local.customClearAllItems();
            router.navigate(['/login'], { queryParamsHandling: 'merge' });
            return false;
        }
    }
};

async function isAuthenticated() {
    const localService = new localStorageService();
    if (!localService.customGetItem('token') || localService.customGetItem('token') == null || localService.customGetItem('reset_password_token')) {
        return false;
    } else {
        return true;
    };
}